var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.$can('events.print.terms') && this.event.status !== 2))?_c('button',{staticClass:"btn btn-fill btn-wd btn-default btn-block btn-router",on:{"click":function($event){return _vm.handleDocumentsPrint()}}},[_vm._v("\n  Imprimir Protocolos de Entrega\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54e195e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Events/Actions/BtnPrintTerms.vue
// module id = uB1t
// module chunks = 10